import { createSnippet, findExampleArticle } from '../../../store';
import templates from './tutorialTemplates.json';

// Identity is shared with the server's welcome templates, regardless of title,
// language, archive state, or the order of the user's other example articles.
export async function getStarterArticle(userId, language = 'en') {
  const existing = await findExampleArticle('tutorial', userId);
  if (existing) return existing;
  const template = templates[language.split('-')[0]] || templates.en;
  const article = createSnippet({ ...template, exampleId: 'tutorial', expectedUserId: userId });
  if (!article?.id || article.user_id !== userId || article.example_id !== 'tutorial') {
    throw new Error('Tutorial was not created for the current account');
  }
  return article;
}
